import { Box, Button, SearchField } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { DateNavigator } from 'modules/core/components/DateNavigator'
import i18n from 'modules/core/lib/i18n'

interface Props {
  range: [Date, Date]
  setRange: (range: [Date, Date]) => void
}

const PlanningToolActions = ({ range, setRange }: Props) => {
  const onClickToday = () => {
    setRange([moment().startOf('month').toDate(), moment().endOf('month').toDate()])
  }

  return (
    <Box flexDirection="row" justifyContent="spaceBetween" paddingX="s24" paddingY="s16">
      <Box flexDirection="row">Filters</Box>
      <Box flexDirection="row" alignItems="center" gap="s8">
        <Button type="secondary" onClick={onClickToday}>
          {i18n.t('common.today')}
        </Button>
        <DateNavigator
          regularPeriods={['month', 'week']}
          startDate={range[0] ?? new Date()}
          endDate={range[1] ?? new Date()}
          onDateRangeChange={(...newRange) => setRange(newRange)}
        />
      </Box>

      <Box flexDirection="row" justifyContent="flexStart" paddingX="s24">
        <Box paddingX="s12">
          <SearchField
            collapsable
            search={''}
            onSearch={() => {}}
            placeholder={i18n.t('common.search')}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default PlanningToolActions
